import React, { useState } from "react";
import style from './channelsCard.module.scss';
import ThreeDotsDropdown from "../../Dropdown/ThreeDotsDropDown/DropDown";
import ToPersianNumber from "../../../helpers/actions/toPersianNumber"
import SwitchButton from "../../SelectionControls/Switch/Switch";
import check from "../../../assets/testIcon/checked.svg"
import cancel from "../../../assets/testIcon/close.svg"
import excl from "../../../assets/icons/editPasswordExcl.svg"

const ChannelsCard = (props) => {
    const [dropdown, setDropdown] = useState(false)
    const [editModal, setEditModal] = useState({
        show: false
    })

    return (
        <React.Fragment>
            <div className={style.modalWrapper}>
            </div>
            <div className={props.data.active === true && props.data.isOnline === false ? style.editPasswordContainer : style.container}>
                <div className={style.dropdownContainer}>
                    <ThreeDotsDropdown
                        tag={props.data.name}
                        items={[
                            {
                                name: 'حذف',
                                onclick: () => props.dropdown("delete", props.data._id, props.data.name),
                                modalOpen: () => {
                                    setDropdown(false)
                                }
                            }
                        ]}
                    />
                </div>
                <div className={style.name}>
                    <div className={style[props.type.value]}></div>
                    <p><span>{typeof props.data.access_token != 'undefined' && props.data.access_token ? "v3 " : "v2 "}</span>{props.data.name}{props.data._id == "66c7067044e53ffa53755c93" ? ' ۲ ' : ''}</p>
                </div>
                <div className={style.toggleWrapper}>
                    <SwitchButton
                        value={props.data.active}
                        tag={'isPannelActive'}
                        disabled={false}
                        onclick={(id, active) => props.toggleHandlerParent(props.data._id, !active, props.type)}
                    />
                </div>
                <div className={style.dateWrapper}>{ToPersianNumber((props.data.createTime))}</div>
                <div className={style.conditionWrapper}>
                    <label className={style.connection}>
                        <div className={style.tooltipWrap}>
                            {props.data.active === false ? <div className={style.resetPasswordWrapper}>
                                <img src={cancel} />
                                <p></p>
                            </div> : props.data.isOnline === true ?
                                <div className={style.resetPasswordWrapper}>
                                    <img src={check} />
                                    <p></p>
                                </div>
                                : <div
                                    className={style.resetPasswordWrapper}
                                    onClick={() => props.dropdown("edit", props.data._id, (props.data.username ? props.data.username : props.data.email), props.type, (typeof props.data.access_token != 'undefined' && props.data.access_token ? true : false))}
                                >
                                    <img src={excl} />
                                    <p>نیاز به اتصال مجدد</p>
                                </div>}
                        </div>
                    </label>
                </div>

                {props.data.isOnline === false && props.data.active === true ? <div className={style.buttonWrapper}>
                    <div
                        className={style.editButton}
                        onClick={() => props.dropdown("edit", props.data._id, (props.data.username ? props.data.username : props.data.email), props.type, (typeof props.data.access_token != 'undefined' && props.data.access_token ? true : false))}
                    >
                        {/* <div className={style.icon}></div> */}
                        اتصال مجدد
                    </div>
                </div>
                    :
                    <div className={style.buttonWrapper}>
                        <div className={style.disabledButton}>
                            اتصال مجدد
                        </div>
                    </div>
                }
            </div>
        </React.Fragment>
    )
}
export default ChannelsCard

